<template>
    <div class="pageTableUsers">

        <ListTableHeader :route="elementRoute" :text-header="$t(' Kampanię ')"
                         :permission-param="`edit_campaign`"
                         :text-button="`+ ` + $t('Dodaj Kampanię')"></ListTableHeader>

        <div class="row">
            <div class="col-12">
                <perfect-scrollbar class="scroll-table">
                    <b-table
                            striped
                            :items="elementsFiltered"
                            :fields="fields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            class="custom table-users"
                            :tbody-tr-class="rowClass"
                    >
                        <template slot="top-row" class="sub-header">
                            <td :key="key" v-for="(field, key) in fields">
                                <template v-if="[2,0,1].indexOf(key) !== -1">
                                    <div class="d-flex ">
                                        <div class="input-group sm custom search ">
                                            <input type="text"
                                                   :placeholder="$t('Wyszukaj')"
                                                   v-model="filters[field.key]"
                                                   class="form-control sm custom">
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>
                        <!---->
                        <template slot="companyId" slot-scope="scope">
                            {{ scope.item.companyId }}
                        </template>

                        <template slot="title" slot-scope="scope">
                            {{ scope.item.title }}
                        </template>

                        <template slot="address" slot-scope="scope">
                            <p>
                                {{ scope.item.country.name }}
                            </p>
                            <p>
                                {{ scope.item.city }}
                            </p>
                            <p>
                                {{ scope.item.postalCode }}
                            </p>
                            <p>
                                {{ scope.item.mainAddress }}
                            </p>
                        </template>
                        <template slot="dateFrom" slot-scope="scope">
                            <div class="min-w-40px"></div>
                        </template>
                        <template slot="dateTo" slot-scope="scope">
                            <div class="min-w-40px"></div>
                        </template>

                        <template slot="actions" slot-scope="scope">
                            <div class="wrap-ico-btn d-flex justify-content-center align-items-center h-100 ">
                                <DeleteButton :item-id="scope.item.id" :return-param="`deleteCompany`"
                                              :permission-param="`delete_company`">
                                </DeleteButton>
                            </div>
                        </template>
                        <!--<template slot="functions" slot-scope="scope">
                            <div class="wrap-ico-btn d-flex justify-content-center align-items-center">
                                <b-dropdown class="custom" toggle-tag="a" variant="link">
                                    <template slot="text">
                                        <span class="icon icon-more"></span>
                                    </template>
                                    <b-dropdown-item>
                                        <DropdownButton :route="`admin.outposts`" :query="{companyId: scope.item.id}"
                                                        :title="`Placówki`"
                                                        :permission-param="`get_outlet`"></DropdownButton>
                                    </b-dropdown-item>
                                    <b-dropdown-item>
                                        <DropdownButton :route="`admin.users`" :query="{companyId: scope.item.id}"
                                                        :title="`Użytkownicy`"
                                                        :permission-param="`get_user`"></DropdownButton>
                                    </b-dropdown-item>
                                    <b-dropdown-item>
                                        <DropdownButton :route="`admin.devices`" :query="{companyId: scope.item.id}"
                                                        :title="`Urządzenia`"
                                                        :permission-param="`get_device`"></DropdownButton>
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#">
                                        <b-link>
                                            {{ $t('Alerty') }}(todo)
                                        </b-link>
                                    </b-dropdown-item>
                                    <b-dropdown-item>
                                        <DropdownButton :route="`admin.invoices`" :query="{companyId: scope.item.id}"
                                                        :title="`Faktury`"
                                                        :permission-param="`get_invoice`"></DropdownButton>
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#">
                                        <b-link>
                                            {{ $t('Administracja') }}(todo)
                                        </b-link>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </template>-->
                    </b-table>
                </perfect-scrollbar>
            </div>
        </div>
        <b-row>

            <b-pagination
                    v-show="totalRows > perPage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class=" custom"
            ></b-pagination>

        </b-row>
        <confirmDeleteModal></confirmDeleteModal>
        <confirmBlockModal></confirmBlockModal>
    </div>

</template>

<script>
import confirmDeleteModal from '@/components/Modals/ConfirmDeleteModal'
import confirmBlockModal from '@/components/Modals/ConfirmBlockModal'
import { mapActions } from 'vuex'
import nonStandartFilterMixin from '@/mixins/nonStandartFilterMixin'

import EditButton from '@/components/Buttons/EditButton'
import DeleteButton from '@/components/Buttons/DeleteButton'
import PreviewButton from '@/components/Buttons/PreviewButton'
import BlockButton from '@/components/Buttons/BlockButton'
import DropdownButton from '@/components/Buttons/DropdownButton'
import ListTableHeader from '@/components/Headers/ListTableHeader'

export default {
  name: 'Campaigns',
  components: {
    confirmDeleteModal,
    confirmBlockModal,
    EditButton,
    DeleteButton,
    PreviewButton,
    BlockButton,
    DropdownButton,
    ListTableHeader
  },
  mixins: [nonStandartFilterMixin],
  data () {
    return {
      elementRoute: 'admin.campaign',
      fields: [
        { key: 'companyId', label: 'ID Firmy', sortable: true },
        { key: 'jednostki', label: 'Information from Unit', sortable: true },
        { key: 'rejestracja', label: 'System registration', sortable: true },
        { key: 'powiadomienie', label: 'Notification'},
        { key: 'firma', label: 'Company'},
        { key: 'wylot', label: 'Outlet'},
        { key: 'actions', label: 'Operacje' }
      ]
    }
  },
  methods: {
    ...mapActions(['getCompanies']),
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    }
  },
  computed: {
    elements () {
      return this.$store.getters.companies
    }
  },
  created () {
    this.getCompanies()
  }
}
</script>

<style scoped>

</style>
